import * as React from "react";
import ForgotPassword from "../../presentations/ForgotPassword";

const ForgotPasswordContainer = () => {
  return (
    <div>
      <ForgotPassword></ForgotPassword>
    </div>
  );
};

export default ForgotPasswordContainer;
